import loadable from '@loadable/component';
import { useHeaderV2 } from './useHeaderV2';

const Header = loadable(
  () => import('@/pages/CompanyReport/components/Overview/components/Header'),
  {
    resolveComponent: (component) => component.Header,
  }
);

const DeprecatedHeader = loadable(
  () =>
    import(
      '@/pages/CompanyReport/components/Overview/components/DeprecatedHeader'
    )
);

export const OverviewHeader = () => {
  const { hasNewHeader, variantName, loading } = useHeaderV2();

  if (loading) {
    return (
      <span className="mb-0 block h-auto min-h-[446px] w-full animate-pulse rounded-md bg-surface-3 sm:min-h-[456px] md:min-h-[227px] lg:mb-4 lg:min-h-[242px]" />
    );
  }

  if (hasNewHeader) {
    return <Header variantName={variantName} />;
  }

  return <DeprecatedHeader minHeight />;
};
